import { ResolveDepartmentManagerRequestSchema, ResolveDepartmentManagerResponseSchema } from './resolve-department-manager.schema';
/**
 * Resolve Department Manager Contract
 * PATCH /api/v2/initialize/departments/:id/resolve-manager
 * Manually resolves an unresolved department by assigning a manager
 */ export const resolveDepartmentManagerContract = {
    method: 'PATCH',
    path: '/api/v2/initialize/departments/:id/resolve-manager',
    requestSchema: ResolveDepartmentManagerRequestSchema,
    responseSchema: ResolveDepartmentManagerResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - department or manager not found, department already resolved, or invalid input',
            401: 'Unauthorized - user not authenticated'
        }
    },
    description: 'Assigns a manager to a department whose manager is still unresolved'
};

//# sourceMappingURL=resolve-department-manager.contract.js.map